import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters} from 'src/modules/entitlements/typedef';

export const userEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementsFilters
>('userEntitlementsState', undefined);

export const userEntitlementsStateActions = userEntitlementsStateSlice.actions;
export const userEntitlementsStateSelector: CachedTableStateSelector<undefined, undefined, EntitlementsFilters> =
    state => state.userPage.tabs.userEntitlements.assigned.state;
